import CandidatureAddByOrderIdRequest from "../../../api/raily/candidature/add-by-order-id/candidature-add-by-order-id.request";
import CandidatureAddByOrderIdParams from "./candidature-add-by-order-id-params";

const create = (
  params: CandidatureAddByOrderIdParams,
): CandidatureAddByOrderIdRequest => {
  return {
    driverId: params.driverUuid,
    orderId: params.orderUuid,
    acceptImmediately: params.acceptImmediately,
    planEntryId: params.planEntryUuid,
    taxiCorporationId: params.taxiCorporationUuid,
  };
};

const candidatureAddParamsFactory = {
  create,
};

export default candidatureAddParamsFactory;
